"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.creator.title': 'Creador de publicaciones',
    'socialMediaPlan.creator.subtitle': 'Brief → Vista previa IA → Planificar',
    'socialMediaPlan.creator.selectPlatform': 'Selecciona al menos una plataforma',
    'socialMediaPlan.creator.fillBrief': 'Introduce tema y plataformas',
    'socialMediaPlan.creator.aiError': 'Generación IA fallida.',
    'socialMediaPlan.creator.generate.title': 'Generar contenido para cada plataforma',
    'socialMediaPlan.creator.generate.desc': 'Completa el brief y genera.',
    'socialMediaPlan.creator.generateBtn': 'Generar con IA',
    'socialMediaPlan.creator.generating': 'Generando...',
    'socialMediaPlan.creator.manually': 'Escribir manualmente',
    'socialMediaPlan.creator.regenerate': 'Regenerar todo',
    'socialMediaPlan.creator.caption': 'Pie de foto',
    'socialMediaPlan.creator.imagePrompt': 'Prompt de imagen',
    'socialMediaPlan.creator.imagePromptPlaceholder': 'Describe la imagen...',
    'socialMediaPlan.creator.generateImage': 'Generar imagen',
    'socialMediaPlan.creator.imagePromptRequired': 'Introduce primero el prompt',
    'socialMediaPlan.creator.imageError': 'Generación de imagen fallida.',
    'socialMediaPlan.creator.videoUpload': 'Archivo de vídeo (YouTube / TikTok)',
    'socialMediaPlan.creator.videoUploadHint': 'Requerido para YouTube y TikTok.',
    'socialMediaPlan.creator.videoChoose': 'Elegir archivo de vídeo',
    'socialMediaPlan.creator.imageSection': 'Imagen',
    'socialMediaPlan.creator.imagePromptLabel': 'Generar con IA',
    'socialMediaPlan.creator.imageUploadLabel': 'O sube tu propia imagen',
    'socialMediaPlan.creator.imageChoose': 'Elegir archivo de imagen',
    'socialMediaPlan.creator.imageClear': 'Eliminar imagen',
    'socialMediaPlan.creator.videoUploadOnNext': 'El video se subirá al hacer clic en Siguiente.',
    'socialMediaPlan.creator.videoReady': 'Video listo para publicar.',
    'socialMediaPlan.creator.videoError': 'Error al subir el vídeo.',
    'socialMediaPlan.creator.tip2026Title': 'Sugerencia de tendencias 2026',
    'socialMediaPlan.creator.tip2026Text': 'El contenido corto y auténtico con un CTA claro sigue generando la mayor interacción. Las galerías y los videos cortos tienen actualmente el mayor alcance orgánico.',
    'socialMediaPlan.creator.brandName': 'Tu marca',
    'socialMediaPlan.creator.now': 'ahora',
    'socialMediaPlan.creator.like': 'Me gusta',
    'socialMediaPlan.creator.comment': 'Comentar',
    'socialMediaPlan.creator.share': 'Compartir',
    'socialMediaPlan.creator.fbPageLabel': 'Página de Facebook',
    'socialMediaPlan.creator.fbNoPages': 'No se encontraron páginas de Facebook. Conecta tu cuenta en ajustes.',
    'socialMediaPlan.creator.liPageLabel': 'Página de LinkedIn',
    'socialMediaPlan.creator.ptBoardLabel': 'Tablero de Pinterest',
    'socialMediaPlan.creator.ptNoBoards': 'No se encontraron tableros de Pinterest. Conecta tu cuenta en ajustes.',
    'socialMediaPlan.creator.postContent': 'Contenido de la publicación',
    'socialMediaPlan.creator.hashtags': 'Hashtags',
    'socialMediaPlan.creator.hashtagsHint': 'separados por espacio',
    'socialMediaPlan.creator.aiInsightTitle': 'Sugerencia de IA',
    'socialMediaPlan.creator.bestTime': 'Mejor hora:',
    'socialMediaPlan.creator.charLimit': 'Límite de caracteres:',
    'socialMediaPlan.creator.videoRemove': 'Eliminar vídeo',
};
